Jasper = window.Jasper || {};

Jasper.Textarea = {
    init : function() {
        Jasper.Textarea.initTinyMCE();
    },
    initTinyMCE : function() {
        tinyMCE.PluginManager.add('title', function(editor, url) {
          editor.addButton('title', {
            tooltip: 'Toggle Title',
            text: 'Title',
            onClick: function() {
              editor.execCommand('mceToggleFormat', false, 'h3');
            },
            onPostRender: function() {
              var self = this, setup = function() {
                editor.formatter.formatChanged('h3', function(state) {
                  self.active(state);
                });
              };
              
              if (editor.formatter) {
                setup();
              } else {
                editor.on('init', setup);
              }
            }
          });
        });

        tinymce.init({
          selector : '.tinymce',
          toolbar : 'undo redo | title | bold italic underline | alignleft aligncenter alignright alignjustify | bulllist numlist outdent indent',
          menubar : false,
          statusbar : false,
          plugins : 'title',
          content_css : "/css/tinymce.css",
          setup: function (editor) {
            editor.on('change', function () {
                tinymce.triggerSave();
            });
          }
        });
    }
};


$(document).ready(function(){
    Jasper.Textarea.init();
});